import { useMemo, useEffect, useState, useRef } from 'react'
import { Modal, Form, Button, InputGroup } from "react-bootstrap";
import Select from 'react-select';
import { useARDriverQuery, useGetCargoDamageForwardersQuery, useToggleSlotStatusMutation } from '../../../../redux/services/SPL';
import TableFilters from '../../../../Components/common/TableGrid/TableFilters';
import TableTabs from '../../../../Components/common/TableGrid/TableTabs';
import { ReactComponent as ArchiveIcon } from "../../../../assets/images/slotplanning/archive_icon.svg";
import { ReactComponent as Editicon } from "../../../../assets/images/icon_svg/pen_w_line.svg";
import loading_icon from '../../../../assets/images/truck_loading.png';
import unloading_icon from '../../../../assets/images/truck_unloading.png';
import Info_edit from "../../../../assets/images/unverified_fill.png";
import green_check from "../../../../assets/images/verified_fill.png";
import pen from "../../../../assets/images/pen.png";
import info from "../../../../assets/images/info.png";
import { onTabChange, clearSelectedRowsData } from '../../../../redux/features/table/tableSlice';
import { useSelector, useDispatch } from 'react-redux';
import TableGrid from "../../../../Components/common/TableGrid";
import { applyOffsetToDateTime, CallApi, getTodayDateTime, Logout } from '../../../../Components/common/CommonFunctions';
import { toast } from 'react-toastify';
import { withRFSToken } from '../../../../Services/axios';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import ConfModal from '../../../../Components/common/ConfModal';

const SubDriver = () => {

  const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalConf, setModalConf] = useState(false);
  const [confData, setConfData] = useState({});
  const [modalPos, setModalPos] = useState('');
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [disLoading, setDisLoading] = useState(false);
  const [loadingType, setLoadingType] = useState();
  const [selectedField, setSelectedField] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [driverForm, setDriverForm] = useState({
    company_name: "",
    first_name: "",
    surname: "",
    id_number: "",
    id_type: "",
    license: "",
    number: "",
    loading_or_unloading: "",
  });
  const [addDriverModal, setAddDriverModal] = useState(false);
  const [dvLink, setDvLink] = useState();
  const [originalLink, setOriginalLink] = useState('');
  const [bothAccess, setBothAccess] = useState(false);
  const [linkModal, setLinkModal] = useState(false);
  const buildFilterParams = (filtersObj) => {
    const entries = Object.entries(filtersObj);
    const params = {};

    if (!entries.length) return params;

    entries.forEach(([field, value], index) => {
      params[`filtervalue${index}`] = value;
      params[`filtercondition${index}`] = "CONTAINS";
      params[`filteroperator${index}`] = 0;
      params[`filterdatafield${index}`] = field;
    });

    params.filterscount = entries.length;

    return params;
  };
  const queryParams = useMemo(() => {
    const filterParams = buildFilterParams(filters);
    const params = {
      ...filterParams,
      // type: "security",
      pagenum: pageDetails.pagenum,
      pagesize: pageDetails.pagesize,
      recordstartindex: pageDetails.recordstartindex,
      recordendindex: pageDetails.recordendindex,
    };
    if (sortby?.sortdatafield) {
      params.sortdatafield = sortby.sortdatafield;
      params.sortorder = sortby.sortorder;
    }
    if (tab?.value && tab.value !== "all" && tab.key) {
      params[tab.key] = tab.value;
    }
    return params;
  }, [filters, pageDetails, sortby]);

  const { data: myData, isFetching, refetch } = useARDriverQuery(queryParams, {
    skip: pageDetails.pagesize === 0,
    refetchOnMountOrArgChange: true,
    pollingInterval: 900000,
  });
  const openDriverModal = () => {
    setAddDriverModal(true)
    setDriverForm({});
    setLoadingType();
  }
  const openModal = async () => {
    try {
      const res = await withRFSToken.post('vehicle-management/generate-link', { type: 'Driver' });
      const innerData = res?.data?.response_data;
      if (res.data.response_code === 200) {
        const innerData = res?.data?.response_data;
        setDvLink(innerData?.link)
        setOriginalLink(innerData?.link)
        setBothAccess(false)
        setLinkModal(true);
      } else {
        toast.error(res.data.response_msg)
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  }
  const closeConfirm = () => {
    setLinkModal(false);
  }
  const closeDriverConfirm = () => {
    setAddDriverModal(false)
  }
  const handleDriverChange = (e) => {
    const { name, value } = e.target;
    setDriverForm((prev) => ({ ...prev, [name]: value }));
  };
  const handleCopy = () => {
    if (inputRef.current) {
      inputRef.current.select();
      inputRef.current.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(inputRef.current.value);
    }
  };
  const activateLink = () => {
    const url = inputRef.current.value;
    const logoutUrl = localStorage.getItem('LogOut');
    if (url) {
      window.open(
        url,
        '_blank',
        'noopener,noreferrer,width=1000,height=800' 
      );
    }
    Logout()
    // localStorage.clear();
    // window.location.replace(logoutUrl);
  };
  const idTypeOptions = [
    { value: "Driver License", label: "Driver License" },
    { value: 'Passport', label: 'Passport' },
  ];
  const validateDriverForm = () => {
    if (!driverForm.company_name?.trim()) {
      toast.error("Company Name is required");
      return false;
    }
    if (!driverForm.first_name?.trim()) {
      toast.error("Driver First Name is required");
      return false;
    }
    if (!driverForm.surname?.trim()) {
      toast.error("Driver Last Name is required");
      return false;
    }
    if (!driverForm.id_type) {
      toast.error("ID Type is required");
      return false;
    }
    if (!driverForm.id_expiry) {
      toast.error("ID Expiry is required");
      return false;
    }
    if (!driverForm.license?.trim()) {
      toast.error("License Plate No. is required");
      return false;
    }
    if (!loadingType) {
      toast.error("Please select Loading or Unloading");
      return false;
    }
    if (!driverForm.cmr?.trim()) {
      toast.error("Document Reference is required");
      return false;
    }
    return true;
  };
  const handleDriverSubmit = async () => {
    if (!validateDriverForm()) return;
    try {
      setDisLoading(true);
      const payload = {
        ...driverForm,
        loading_or_unloading: loadingType,
      };
      const res = await withRFSToken.post(`${process.env.REACT_APP_RFS_URL}vehicle-management/save-driver`, payload,);
      if (res.data?.response_code === 200) {
        const msg = res.data?.response_msg || "Driver saved successfully!";
        toast.success(msg);
        setAddDriverModal(false);
        refetch();
      } else {
        const msg = res.data?.response_msg || "Error saving driver";
        toast.error(msg);
        // console.warn("Driver save business error:", res.data);
      }
    } catch (err) {
      console.error("Driver save error:", err.response?.data || err.message);
      toast.error("Error saving driver");
    } finally {
      setLoading(false);
      setDisLoading(false);
      setAddDriverModal(false);
    }
  };

  const filtersConfig = [
    {
      type: "button",
      text: "Add Driver",
      click: openDriverModal,
      icon: 'plus',
      class: 'create_btn'

    },
    // {
    //   type: "button",
    //   text: "Generate Link",
    //   click: openModal,
    //   class: 'create_btn'

    // },
    {
      type: "input",
      field: "company_name",
      placeholder: "Company Name",
    }];

  const tabsConfig = [
    { label: "Open", value: "A", paramKey: "tab" },
    { label: "Archive", value: "R", paramKey: "tab" },
  ];
  const handleModalConf = () => {
    setModalConf(true)
  }
  const handleModalClose = () => {
    setShowModal(false);
  }
  const handleSave = (pos) => {

    let payload = {};
    if (modalPos === 'A') {
      payload = { ...formData, gate_in: getTodayDateTime(), }
    } else {
      if (pos === 'E') {
        payload = { gate_in: formData.gate_in.split('T')[0] + ' ' + formData.gate_in.split('T')[1] }
      } else {
        payload = { gate_in: '' }
      }
    }
    CallApi({
      endPoint: `trip-management/update-slot/${formData.id}`,
      method: 'patch',
      payload: payload,
      onSuccess: (res) => {
        const resCode = res.data.response_code;
        if (resCode === 200) {
          toast.success(res.data.response_msg || "Saved successfully");
          handleModalClose();
          if (pos === 'C') {
            setModalConf(false)
          }
          refetch()
        } else {
          toast.error(res.data.response_msg || "Error")
        }
      },
      onError: (msg) => toast.error(msg)
    });

  }
  const verifiedConf = async (id) => {
      const payload = {id: id,}
      try {
          const res = await withRFSToken.post('vehicle-management/update-driver-verify-status', payload);
          const innerData = res?.data?.response_data;
          if (res.data.response_code === 200) {
              setModalConf(false);
              refetch();
          } else {
              toast.error(res.data.response_msg)
          }
      } catch (error) {
          console.error('Error fetching settings:', error);
      }
  }
  const confModalClose = () => {
      setModalConf(false);
  }
  const handleMoveToActArc = () => {
    if (!selectedRows?.length) {
      toast.error('Please select row first');
      return;
    }
    const isActiveTab = tab?.value === 'A';
    setConfData({
      header: `Selected Data move to ${isActiveTab ? 'Archive' : 'Active'}`,
      subHeader: `Are you sure you want to ${isActiveTab ? 'Archive' : 'Activate'}?`,
      primaryBtn: 'Confirm',
      secondaryBtn: 'Cancel',
      modalConf: tabChangeConf,
    });
    setModalConf(true);
  };
  const tabChangeConf = async () => {
    if (!selectedRows?.length) {
      toast.error('No rows selected');
      return;
    }
    const isActiveTab = tab?.value === 'A';
    const payload = {
      tab: 'Driver',
      id: selectedRows.map(row => row.id),
      status: isActiveTab ? 0 : 1, 
    };
    try {
      const res = await withRFSToken.post(
        'vehicle-management/update-activity-status',
        payload
      );
      if (res.data.response_code === 200) {
        setModalConf(false);
        refetch();
        dispatch(clearSelectedRowsData());
      } else {
        toast.error(res.data.response_msg);
      }
    } catch (error) {
      console.error('Error updating status:', error);
      toast.error('Something went wrong');
    }
  };
  const columns = [
    { label: "Company Name", field: "company_name", enableSearch: false, cls: 'tw-7' },
    { label: "First Name", field: "first_name", enableSearch: false, cls: 'tw-7' },
    { label: "Last Name", field: "surname", enableSearch: false, cls: 'tw-8' },
    { label: "ID Type", field: "id_type", enableSearch: false, cls: 'tw-8' },
    { label: "ID Expiry", field: "id_expiry", enableSearch: false, cls: 'tw-8' },
    { label: "ID Check", field: "is_verified", enableSearch: false, cls: 'tw-8',
      renderCell: (row) => {
        const handleClick = () => {
          setConfData({
            header: row?.is_verified == 0 ? "ID Verified ?" : "ID Unverified ?",
            primaryBtn: "Yes",
            secondaryBtn: "No",
            modalConf: () => verifiedConf(row?.id),
          });
          setModalConf(true);
        };
        if (tab?.value === 'A') {
          return row.is_verified == 1 ? (
            <div
              className=""
              onClick={handleClick}
            >
              <span>
               <b>Verified</b>
              </span>
            </div>
          ) : (
            <div
              className=""
              onClick={handleClick}
            >
              <span>
                <b>Unverified</b>
              </span>
            </div>
          );
        } else {
          return (
            <span>
              {row.is_verified == 1 ? "Checked" : "Unchecked"}
            </span>
          );
        }
      }
    },
    { label: "Doc Reference", field: "cmr", enableSearch: false, cls: 'tw-8' },
    { label: "License Plate", field: "license", enableSearch: false, cls: 'tw-8' },
    { label: "Trailer ID", field: "trailer_plate", enableSearch: false, cls: 'tw-8' },
    { label: "(Un) Loading", field: "loading_or_unloading", enableSearch: false, cls: 'tw-7' },
    { label: "Date Time In", field: "created_at", enableSearch: false, cls: 'tw-8',
        renderCell: (row) => {
        const formatted = applyOffsetToDateTime(row.created_at, "L");
        return (
          <div>
            {formatted}
          </div>
        );
      }
    },
    { label: "Date Time Out", field: "checkout_date", enableSearch: false,
      renderCell: (row) => {
        const handleClick = () => {
          if (tab?.value !== 'A') return;
          setSelectedField("checkout_date");
          setSelectedRow(row);
          if (row?.checkout_date) {
            setDateTimeValue(row.checkout_date);
          } else {
            setDateTimeValue(getTodayDateTime());
          }
          setEditModal(true);
        };
        if (tab?.value === 'A') {
          return row.checkout_date ? (
            <span>
              {row.checkout_date}
              <Editicon
                onClick={handleClick}
                style={{ cursor: "pointer", marginLeft: "5px" }}
              />
            </span>
          ) : (
            <button className="edit_btn" onClick={handleClick}>
              <Editicon/> Set
            </button>
          );
        } else {
          if (!row.checkout_date) return <span>-</span>;
          const date = new Date(row.checkout_date);
          const formatted = date.toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
          });
          return <span>{formatted}</span>;
        }
      }
    },
    // {
    //   label: "Signature", field: "signature_text", enableSearch: false,
    //   renderCell: () => (
    //     <img className="signature-info-icon" src={info}  onClick={() => setShowModal(true)} style={{ cursor: "pointer" }}/>
    //   )
    // }
  ];
  const transformedRows = useMemo(() => {
    return (
      myData?.Rows?.map((item) => {
        let timeslot = "";
        if (item?.slot_start_time && item?.slot_end_time) {
          const [, startTimeFull] = item.slot_start_time.split(" ");
          const [, endTimeFull] = item.slot_end_time.split(" ");
          const startTime = startTimeFull.slice(0, 5);
          const endTime = endTimeFull.slice(0, 5);
          timeslot = `${startTime} - ${endTime}`;
        }
        return {
          ...item,
          planned_date_time: item.planned_date_time
            ? item.planned_date_time.slice(0, 16)
            : "",
          timeslot,
        };
      }) || []
    );
  }, [myData]);
  useEffect(() => {
    // if (isMounted.current) return;
    // fetchWarehousOrgnaziation();
    dispatch(onTabChange({ key: 'tab', value: "A" }));
    // isMounted.current = true;
  }, []);

  const [toggleSlotStatus, { isLoading: archiveLoading }] = useToggleSlotStatusMutation();
  const bulkActions = tab?.value === "A"
    ? [{ label: "Archive", action: handleMoveToActArc, icon: ArchiveIcon }]
    : tab?.value === "R"
      ? [{ label: "Activate", action: handleMoveToActArc, icon: ArchiveIcon }]
      : [];

  const [editModal, setEditModal] = useState(false);
  const [dateTimeValue, setDateTimeValue] = useState(""); 

  const formatDateTime = (value) => {
    const date = new Date(value);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
       const saveDateTime = async () => {
            try {
              setDisLoading(true);
                const token = "Bearer " + localStorage.DVR;
                const payload = {
                    id: selectedRow.id,
                    type: "Driver",
                    checkout_date : formatDateTime(dateTimeValue),
                };
                const res = await withRFSToken.post('vehicle-management/set-checkout-in-time', payload);
                if(res?.data?.response_code === 200){
                setEditModal(false);
                toast.success("Updated Successfully");
                refetch();}
                else{
                   toast.error(res?.data?.response_msg || "Error Saving") 
                }
                setDisLoading(false);
            } catch (error) {
                // console.error("Save Failed:", error.response?.data || error.message);
                toast.error("Failed to update. Please try again.");
                setDisLoading(false);
            }
        };
  return (
    <>
     {disLoading &&
                        <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
                      }
      {modalConf &&
          <ConfModal
              header={confData.header}
              subHeader={confData.subHeader}
              modalConf={confData.modalConf}
              closeModal={confModalClose}
              primaryBtn={confData.primaryBtn}
              secondaryBtn={confData.secondaryBtn}
          />
      }
      <div className="main-content">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <TableFilters filtersConfig={filtersConfig} />
          <TableTabs tabs={tabsConfig} />
        </div>

        <div>
          <TableGrid
            columns={columns}
            rows={transformedRows}
            checkboxSelection={true}
            totalRecords={myData?.TotalRows || 0}
            loading={isFetching}
            bulkActions={bulkActions}
            rowKey="id"
          />
        </div>
      </div>
      <Modal show={editModal} onHide={() => setEditModal(false)} centered className="modal_bgw primary_modal">
      <Modal.Header closeButton>
          {/* <Modal.Title>Edit {selectedField === "checkin_date" ? "Date Time In" : "Date Time Out"}</Modal.Title> */}
          <Modal.Title>Edit Date Time Out
            <p>Set or update checkout date and time</p>
          </Modal.Title>
      </Modal.Header>
      <Modal.Body>
          <Form.Group>
              <Form.Label>Select Date & Time</Form.Label>
              <Form.Control
                  type="datetime-local"
                  value={dateTimeValue}
                  onChange={(e) => setDateTimeValue(e.target.value)}
              />
          </Form.Group>
      </Modal.Body>
      <Modal.Footer>
          <Button variant="primary" onClick={saveDateTime}>
              Save
          </Button>
      </Modal.Footer>
      </Modal>
      <Modal show={linkModal} onHide={closeConfirm} className="modal_bgw primary_modal change_type" centered>
        <Modal.Header closeButton><Modal.Title>Generate Link</Modal.Title></Modal.Header>
        <Modal.Body>
          {dvLink && <><Form.Label>Link</Form.Label>
            <div className='d-flex gap-2'>
              <Form.Control
                type="text"
                ref={inputRef}
                name="link"
                value={dvLink || ''}
                readOnly
              />
              <Button onClick={handleCopy} > Copy </Button>
            </div></>}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-50 mx-auto are_bottom">
            <Button variant="secondary" onClick={closeConfirm}> Cancel</Button>
            <Button variant="primary" onClick={activateLink}> Activate </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={addDriverModal} onHide={closeDriverConfirm} className="modal_bgw primary_modal" centered>
        <Modal.Header closeButton>
            <Modal.Title>Driver Registration
              <p>Create a new driver profile</p>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form className="pt-0">
              <Form.Group className='mb-2'>
                <Form.Label>Company Name<span className="text-danger">*</span> </Form.Label>
                <Form.Control
                  type="text"
                  name="company_name"
                  value={driverForm.company_name}
                  onChange={handleDriverChange}
                // placeholder="Driver name"
                />
              </Form.Group>
              <Form.Group className='mb-2'>
                <Form.Label>Driver First Name <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="first_name"
                  value={driverForm.first_name}
                  onChange={handleDriverChange}
                // placeholder="Driver name"
                />
              </Form.Group>
              <Form.Group className='mb-2'>
                <Form.Label>Driver Last Name <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="surname"
                  value={driverForm.surname}
                  onChange={handleDriverChange}
                // placeholder="Driver name"
                />
              </Form.Group>
              <div className='d-flex gap-2 mb-2'>
                <Form.Group style={{ width: '50%' }}>
                  <Form.Label>ID Type <span className="text-danger">*</span></Form.Label>

                  <InputGroup>
                    <div className='w-100'>
                      <Select
                        options={idTypeOptions}
                        // filterOption={filterPhoneOption}
                        // placeholder="ID Type"
                        value={idTypeOptions.find(o => o.value === driverForm?.id_type) || null}
                        onChange={(opt) => {
                          setDriverForm(prev => ({
                            ...prev,
                            id_type: opt ? opt.value : ''
                          }));
                        }}
                        isClearable
                      />
                    </div>
                  </InputGroup>
                </Form.Group>
                <Form.Group style={{ width: '50%' }}>
                  <Form.Label>ID Expiry <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="date"
                    name="id_expiry"
                    value={driverForm.id_expiry}
                    onChange={handleDriverChange}
                  />
                </Form.Group>
              </div>

              {/* License */}
              <div className='d-flex mb-3 gap-2'>
                <Form.Group style={{ width: '50%', }}>
                  <Form.Label>License Plate No. <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="license"
                    value={driverForm.license}
                    onChange={handleDriverChange}
                  // placeholder="License plate no."
                  />
                </Form.Group>
                <Form.Group style={{ width: '50%', }}>
                  <Form.Label>Trailer ID Plate <span className="text-danger"></span></Form.Label>
                  <Form.Control
                    type="text"
                    name="trailer_plate"
                    value={driverForm.trailer_plate}
                    onChange={handleDriverChange}
                  // placeholder="Trailer ID Plate"
                  />
                </Form.Group>
              </div>

              {/* Loading / Unloading */}
              <Form.Group className="">
                {/* <Form.Label>Loading/Unloading</Form.Label> */}
                <div className="d-flex gap-2 addDriverMdl">
                  <Button
                    variant={loadingType === "Loading" ? "secondary" : "outline-secondary"}
                    onClick={() => setLoadingType("Loading")}
                    style={{ flex: 1 }}
                    className="loading_unloading_btn"
                  >
                    <img src={loading_icon} alt='loading' className='loading_icon pe-2' />
                    Loading
                  </Button>
                  <Button
                    variant={loadingType === "Unloading" ? "secondary" : "outline-secondary"}
                    onClick={() => setLoadingType("Unloading")}
                    style={{ flex: 1 }}
                    className="loading_unloading_btn"
                  >
                    <img src={unloading_icon} alt='unloading' className='loading_icon pe-2' />
                    Unloading
                  </Button>
                </div>
              </Form.Group>
              <Form.Group className='mt-2'>
                <Form.Label>Document Reference <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="cmr"
                  value={driverForm.cmr}
                  onChange={handleDriverChange}
                // placeholder="CMR Reference Number"
                />
              </Form.Group>

            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleDriverSubmit}>
              Submit
          </Button>
      </Modal.Footer>
      </Modal>

      <Modal className="modal_bgw primary_modal" show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Signature Info
            <p>See signature details</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
            <p className='mb-3'>To View This Signature. <br /> Please Contact Cargohub <b>Support Team</b></p>
        </Modal.Body>
    </Modal>
    </>
  )
}

export default SubDriver